import { ref } from 'vue';

export function useDateFormatter() {
  const defaultFormat = ref('DD-MM-YYYY');

  const formatDate = (date, format = defaultFormat.value) => {
    console.log('Formatting date:', date, 'with format:', format);
    if (!date) return '';

    const rawDate = new Date(date);
    if (isNaN(rawDate)) return 'Invalid Date';

    const yearFull = rawDate.getFullYear();          // 2025
    const yearShort = String(yearFull).slice(-2);    // 25
    const month = String(rawDate.getMonth() + 1).padStart(2, '0');
    const day = String(rawDate.getDate()).padStart(2, '0');

    // Replace both uppercase and lowercase tokens
    let formatted = format
      .replace(/YYYY/g, yearFull)
      .replace(/YY/g, yearShort)
      .replace(/MM/g, month)
      .replace(/DD/g, day)
      .replace(/dd/g, day)
      .replace(/mm/g, month)
      .replace(/yy/g, yearShort);

    console.log('Formatted date:', formatted);
    return formatted;
  };

  return {
    defaultFormat,
    formatDate,
  };
}
